// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cancelled-screen {
  text-align: center;
  padding: 40px 20px;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.cancelled-message {
  color: #666;
  font-size: 18px;
  max-width: 500px;
  line-height: 1.5;
  padding: 0 10px;
}

.cancelled-submessage {
  color: #888;
  font-size: 16px;
  margin-bottom: 40px;
  max-width: 500px;
  line-height: 1.5;
}

.appointment-details {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 24px;
  margin: 30px auto;
  max-width: 600px;
  text-align: left;
}

.appointment-details h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.detail-row {
  display: flex;
  margin-bottom: 12px;
  font-size: 16px;
}

.detail-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  font-weight: 600;
  color: #666;
  min-width: 120px;
  margin-right: 16px;
}

.detail-value {
  color: #333;
  flex: 1 1;
}

.cancelled-datetime {
  text-decoration: line-through;
  color: #999;
}

.new-booking-button {
  background-color: #1976d2;
  color: white;
  border: none;
  padding: 14px 32px;
  font-size: 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
  min-width: 200px;
}

.new-booking-button:hover {
  background-color: #1565c0;
}

@media (max-width: 600px) {
  .cancelled-message {
    font-size: 16px;
  }
  
  .cancelled-submessage {
    font-size: 14px;
  }
  
  .new-booking-button {
    width: 100%;
    max-width: 300px;
  }
  
  .appointment-details {
    padding: 16px;
    margin: 20px 10px;
  }
  
  .appointment-details h3 {
    font-size: 18px;
  }
  
  .detail-row {
    flex-direction: column;
    margin-bottom: 16px;
  }
  
  .detail-label {
    margin-bottom: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CancelledScreen.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".cancelled-screen {\n  text-align: center;\n  padding: 40px 20px;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.cancelled-message {\n  color: #666;\n  font-size: 18px;\n  max-width: 500px;\n  line-height: 1.5;\n  padding: 0 10px;\n}\n\n.cancelled-submessage {\n  color: #888;\n  font-size: 16px;\n  margin-bottom: 40px;\n  max-width: 500px;\n  line-height: 1.5;\n}\n\n.appointment-details {\n  background-color: #f5f5f5;\n  border-radius: 8px;\n  padding: 24px;\n  margin: 30px auto;\n  max-width: 600px;\n  text-align: left;\n}\n\n.appointment-details h3 {\n  margin: 0 0 20px 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.detail-row {\n  display: flex;\n  margin-bottom: 12px;\n  font-size: 16px;\n}\n\n.detail-row:last-child {\n  margin-bottom: 0;\n}\n\n.detail-label {\n  font-weight: 600;\n  color: #666;\n  min-width: 120px;\n  margin-right: 16px;\n}\n\n.detail-value {\n  color: #333;\n  flex: 1;\n}\n\n.cancelled-datetime {\n  text-decoration: line-through;\n  color: #999;\n}\n\n.new-booking-button {\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  padding: 14px 32px;\n  font-size: 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.3s ease;\n  min-width: 200px;\n}\n\n.new-booking-button:hover {\n  background-color: #1565c0;\n}\n\n@media (max-width: 600px) {\n  .cancelled-message {\n    font-size: 16px;\n  }\n  \n  .cancelled-submessage {\n    font-size: 14px;\n  }\n  \n  .new-booking-button {\n    width: 100%;\n    max-width: 300px;\n  }\n  \n  .appointment-details {\n    padding: 16px;\n    margin: 20px 10px;\n  }\n  \n  .appointment-details h3 {\n    font-size: 18px;\n  }\n  \n  .detail-row {\n    flex-direction: column;\n    margin-bottom: 16px;\n  }\n  \n  .detail-label {\n    margin-bottom: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
